import ManagerModal from './presentational/ManagerModal';

export default ManagerModal;
